module.exports = __webpack_public_path__ + "static/media/tra_giv_tak.def85dc0.png";